export default {"src":"/_next/static/media/blz.d329265e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};